import React, {useMemo, useRef, useState} from 'react';
import Card from "../../../components/card";
import {AgGridReact} from "ag-grid-react";
import {LocalizationAgGrid} from "../../../utils/localization-ag-grid";
import {useNavigate} from "react-router-dom";
import {FaCheck, FaPlus} from "react-icons/fa";
import {FaX} from "react-icons/fa6";
import TruncateCellRenderer from "../../../components/cell-renderer/truncate-cell-renderer";
import PendCellRenderer from "../../../components/cell-renderer/pend-cell-renderer";
import Button from "../../../components/button";
import general from "../../../utils/general";

const OrdersTable = ({orders, id, onlySeeAttendances}) => {
    const navigate = useNavigate();

    const [columnDefs] = useState([
        { field: "id", headerName: "ID", width: 70 },
        { field: "date_initial", headerName: "Abertura",
            cellRenderer: params => {
                return general.formatDate(params.value)
            }
        },
        { field: "date_final", headerName: "Encerramento",
            cellRenderer: params => {
                return general.formatDate(params.value)
            }
        },
        { field: "", headerName: "Pendências", sortable: false, cellRenderer: PendCellRenderer, width: 180 },
        { field: "pend_multiway_desc", headerName: "Multiway", cellRenderer: TruncateCellRenderer, flex: 1, minWidth: 200 },
        { field: "pend_client_desc", headerName: "Clientes", cellRenderer: TruncateCellRenderer, flex: 1, minWidth: 200 },
        { field: "pend_terceiros_desc", headerName: "Terceiros", cellRenderer: TruncateCellRenderer, flex: 1, minWidth: 200 },
        {
            field: "attachs",
            headerName: "Anexos",
            cellClass: "justify-center",
            width: 100,
            cellRenderer: ({value}) => value ? <FaCheck className="text-green-700"/> : <FaX className="text-red-700"/>
        },
    ]);

    const gridRef = useRef();

    const defaultColDef = useMemo(() => ({resizable: false}), []);

    const onCellClicked = (cell) => {
        if (!onlySeeAttendances) navigate(`/orders/form/${cell.data.id}/${id}`)
    };

    const addOrder = () => navigate(`/orders/form/0/${id}`);

    return (
        <Card title="Orderns de serviço" wrapperClass="mt-5">
            <div className={"ag-theme-quartz grid"}>
                <AgGridReact
                    ref={gridRef}
                    rowHeight={32}
                    rowData={orders}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    animateRows={false}
                    suppressRowClickSelection={true}
                    suppressCellFocus={true}
                    onCellClicked={onCellClicked}
                    gridOptions={{localeText: LocalizationAgGrid}}
                    domLayout='autoHeight'
                />
            </div>

            {
                !onlySeeAttendances &&
                <Button onClick={addOrder} target="primary" col="mt-4">
                    <FaPlus/> Adicionar ordem de serviço
                </Button>
            }
        </Card>
    );
};

export default OrdersTable;